"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.renameDocFile = renameDocFile;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
async function renameDocFile(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const { id, filePath } = await deps.resolveDocIdOrThrow(loomRoot, input.id);
    const doc = await deps.loadDoc(filePath);
    if (doc.type !== 'reference') {
        throw new Error(`loom_rename_doc_file only renames reference docs (their filename is a slug). '${id}' is a '${doc.type}' — its filename is machine-owned; use loom_rename to change the title.`);
    }
    // Match the create convention: filename is {slug}-reference.md and the `slug`
    // frontmatter holds the BARE slug (a trailing "reference" word is stripped so a
    // slug like "api-reference" doesn't yield api-reference-reference.md).
    const slug = (0, dist_1.stripTrailingTypeWord)((0, dist_1.toKebabCaseId)(input.newSlug), 'reference');
    if (!slug)
        throw new Error(`Invalid slug '${input.newSlug}'.`);
    const destName = `${slug}-reference.md`;
    const dir = path.dirname(filePath);
    const destPath = path.join(dir, destName);
    if (path.resolve(destPath) === path.resolve(filePath)) {
        return { id, from: path.basename(filePath), to: destName };
    }
    if (await deps.fs.pathExists(destPath)) {
        throw new Error(`A reference '${destName}' already exists in ${path.relative(loomRoot, dir)}.`);
    }
    // Keep the slug frontmatter field in lockstep with the filename, then relocate.
    const updated = { ...doc, slug, updated: (0, dist_1.today)() };
    await deps.saveDoc(updated, destPath);
    if (path.resolve(destPath) !== path.resolve(filePath)) {
        await deps.fs.remove(filePath);
    }
    return { id, from: path.basename(filePath), to: destName };
}
